import { zRoutePointSchemaDom, zRoutePointSchemaCreateDom, } from "@/types/routePoint/routePoint.domain";
import { zRoutePointSchemaDto, zRoutePointSchemaCreateDto, } from "@/types/routePoint/routePoint.dto";
import { AddressInfo } from "@/types/zAddressInfo";
/**
 * Маппер для RoutePoint: DTO <-> Domain
 * Преобразует плоские адресные поля в инкапсулированный класс AddressInfo и обратно
 */
export const RoutePointMapper = {
    /**
     * Преобразование из DTO (плоская структура) в Domain (с инкапсулированным addressInfo)
     */
    toDomain: (dto) => {
        // Validate the routePoint fields
        const safeDto = zRoutePointSchemaDto.parse(dto);
        // Create AddressInfo instance from DTO data
        const addressInfo = AddressInfo.fromPlainObject(safeDto);
        /**
         * сначала парсим плоскую структуру, затем инкапсулируем в AddressInfo
         * это нужно, чтобы убедиться, что все поля адреса валидны
         */
        const routePointFields = zRoutePointSchemaDom.parse({
            ...safeDto,
            addressInfo: addressInfo.toPlainObject(),
        });
        return {
            ...routePointFields,
            addressInfo,
        };
    },
    /**
     * Преобразование из Domain (с AddressInfo) в DTO (плоская структура)
     */
    toDto: (domain) => {
        const safeDomain = zRoutePointSchemaDom.parse(domain);
        // Extract address data from AddressInfo class (internal use)
        return zRoutePointSchemaDto.parse({
            ...safeDomain,
            ...domain.addressInfo.toPlainObject(),
        });
    },
    /**
     * Преобразование из Domain (с AddressInfo) в DTO (плоская структура) для создания
     */
    toCreateDto: (domain) => {
        const { addressInfo } = domain;
        const safeDomain = zRoutePointSchemaCreateDom.parse(domain);
        const addressData = addressInfo.toPlainObject();
        return zRoutePointSchemaCreateDto.parse({
            ...safeDomain,
            ...addressData,
        });
    },
    toCreateDom: (dto) => {
        const safeDto = zRoutePointSchemaCreateDto.parse(dto);
        const addressData = AddressInfo.fromPlainObject(safeDto);
        zRoutePointSchemaCreateDom.parse({
            ...safeDto,
            addressInfo: addressData,
        });
        return {
            ...safeDto,
            addressInfo: AddressInfo.fromPlainObject(safeDto),
        };
    },
};
